import { Alert, Box, Stack } from '@mui/material'

interface ErrorStateProps {
  error: string
}

export const ErrorState = ({ error }: ErrorStateProps) => {
  if (error === 'WebSocket connection error') {
    return (
      <Stack
        fontSize={16}
        flexDirection="row"
        alignItems="center"
        gap={0.5}
        paddingY={3}
        width="100%"
        justifyContent="center"
      >
        No data due to WebSocket Connection error
      </Stack>
    )
  }

  return (
    <Box sx={{ p: 3 }}>
      <Alert severity="error">Failed to load team hole by hole data: {error}</Alert>
    </Box>
  )
}
